// import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";
import { FunctionCloneDeep } from "radium-omnibus";
import OurserviceFirstLoad from "../../select/functions/Ourservice.FirstLoad";

const BasketDeleteOrder = (setCart, type, storage, _id) => {
  setCart((prevCart) => {
    let temp = FunctionCloneDeep([...prevCart]);

    temp = temp?.filter((item) => {
      return item.master_type !== type && item.master_id !== _id;
    });

    const lengthOfPrograms = temp?.filter((item) => {
      return item.master_type;
    }).length;

    if (lengthOfPrograms === 0) {
      storage([]);
      return [];
    }

    if (type === "WATER") {
      const findIndex = temp.findIndex((item) => item.type === type);
      if (findIndex !== -1) {
        temp.splice(findIndex, 1);
      }
    }

    storage([...temp]);

    return [...temp];
  });

  OurserviceFirstLoad();
  // if (type === STATE_CONSTANTS_PROGRAM.MY_WATER) {
  //   setCart((prevCart) => {
  //     let temp = [...prevCart];
  //     const findIndex = temp.findIndex((item) => item._id === _id);
  //     if (findIndex !== -1) {
  //       temp.splice(findIndex, 1);
  //     }
  //     storage([...temp]);
  //     return [...temp];
  //   });
  // } else {
  //   setCart((prevCart) => {
  //     let temp = [...prevCart];
  //     let newTemp = temp?.filter((item) => {
  //       return item.type !== type;
  //     });
  //     storage(newTemp);
  //     return newTemp;
  //   });
  // }
};

export default BasketDeleteOrder;
